const API = process.env.REACT_APP_BACKEND_URL;

const postJson = async (path, body) => {
  const res = await fetch(`${API}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Request to ${path} failed (${res.status})`);
  return res.json();
};

export const postEnquiry = (type, details) => postJson('/api/enquiries', { type, details });

export const postBooking = (form) => postJson('/api/bookings', form);
